/* eslint-disable no-nested-ternary */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from '@emotion/styled';

import Button from '../../../../shared/components/Button/Button';
import { BoxShadow } from '../../../../shared/GlobalStyles';
import { setIsLegendInfoModalShowing } from '../../ducks/habitTrackingDashboardActions';
import LegendSVG from '../../../../shared/images/habit-legend.png';

const ModalOverlay = styled('div')`
  height: 100vh;
  width: 100vw;
  position: absolute;
  background-color: rgba(216, 216, 216, 0.8);
  z-index: 1;
  pointer-events: ${(props) => (props.isActive ? 'auto' : 'none')};
  transition: opacity 0.3s ease;
  opacity: ${(props) => (props.isActive ? 0.5 : 0)};
`;

const ModalContainer = styled('div')`
  position: absolute;
  top: 50%;
  left: 50%;
  margin: -135px 0px 0px -265px;
  background-color: #FFFFFF;
  width: 590px;
  padding: 24px;
  border-radius: 8px;
  font-family: 'Nunito Sans';
  box-shadow: ${BoxShadow};
  z-index: 2;
`;

const HeaderContainer = styled('div')`
  display: flex;
  justify-content: space-between;
`;

const Header = styled('div')`
  font-size: 16px;
  color: #9E9E9E;
`;

const Title = styled('div')`
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 15px;
`;

const DescriptionImage = styled('div')`
  background-image: url(${LegendSVG});
  background-repeat: no-repeat;
  height: 225px;
  width: 545px;
  background-size: contain;
`;

const LegendInfoModal = () => {
  const dispatch = useDispatch();
  const isLegendInfoModalShowing = useSelector(
    (state) => state.habitTrackingDashboard.ui.isLegendInfoModalShowing,
  );

  const handleClose = () => {
    dispatch(setIsLegendInfoModalShowing(false));
  };

  return (
    <>
      <ModalContainer>
        <HeaderContainer>
          <Header>Legend</Header>
          <Button
            icon='remove'
            iconOnly
            onClick={handleClose}
          />
        </HeaderContainer>
        <Title>Habits</Title>
        <DescriptionImage />
      </ModalContainer>
      <ModalOverlay
        isActive={isLegendInfoModalShowing}
        onClick={handleClose}
      />
    </>
  );
};

export default LegendInfoModal;
